import ActivityEmbeddedSitemodel from './ActivityEmbeddedSitemodel'

export default ActivityEmbeddedSitemodel
